import { useValidateListOrder } from '../../filter';
import { useAssetListOrder } from './useAssetListOrder';
import { useSetAssetListOrder } from './useSetAssetListOrder';

export const useValidateAssetListOrder = () => {
  return useValidateListOrder(useAssetListOrder, useSetAssetListOrder);
};
